import ApiFetcher from "../utils/ApiFetcher";
import { put, call } from "redux-saga/effects";
import { sagaListSuccess } from "../actions/ActionTypes";

const REPORT_SUMMARIES = "report_summaries";
const apiFetcher = new ApiFetcher();
export function* fetchReportSummaries(action) {
  try {
    const res = yield call(apiFetcher.findAll, "summaries");
    yield put({
      type: sagaListSuccess(REPORT_SUMMARIES),
      data: res.data
    });
  } catch (e) { }
}



// WEBPACK FOOTER //
// ./src/sagas/reports.js